<template>
  <div> 
    <h4 class="m-b-40">{{formInfo.title}}</h4>
    <a-form :model="form" :label-col="{span:5,offset:0}" :wrapper-col="{span:19,offset:0}" labelAlign="left">
      <div v-for="(item) in componentList" :key="item.id">
         <a-form-item :label="item.customize_name" :required="item.is_sys==1" :style="{'border-bottom':'1px solid #f0f0f0'}" v-if="item.type_mark=='mcz_type_text'" :label-col="{'span':setLabel(item.customize_name)}" :wrapper-col="{'span':setWrapper(item.customize_name)}">
           <a-input v-model:value="item.name" :maxlength="item.length" style="border:none;outline: none;box-shadow: none" :placeholder="item.placeholder_text"/>
         </a-form-item>
         <a-form-item label="手机号" :required="item.is_sys==1" :style="{'border-bottom':'1px solid #f0f0f0'}" v-if="item.type_mark=='mcz_type_phone_check'">
           <a-input v-model:value="item.rulesPhone" maxlength="11" style="border:none;outline: none;box-shadow: none" :placeholder="item.placeholder_text" v-inputFilter:phone/>
         </a-form-item>
         <a-form-item label="验证码" :required="item.is_sys==1" :style="{'border-bottom':'1px solid #f0f0f0'}" v-if="item.type_mark=='mcz_type_phone_check'">
           <div class="s_flex_ali">
               <a-input v-model:value="item.code" maxlength="6" style="border:none;outline: none;box-shadow: none" placeholder="请输入验证码" v-inputFilter:phone/>
               <div style="padding:3px 6px;background:#19be6b;width:120px" class="s_fonts12 s_cfff s_bor5 s_shou text-ac">获取验证码</div>
           </div>
         </a-form-item>
   
          <a-form-item :label="item.customize_name" :required="item.is_sys==1" :style="{'border-bottom':'1px solid #f0f0f0'}" v-if="item.type_mark=='mcz_type_phone'" :label-col="{'span':setLabel(item.customize_name)}" :wrapper-col="{'span':setWrapper(item.customize_name)}">
           <a-input v-model:value="item.phone" maxlength="11" style="border:none;outline: none;box-shadow: none" :placeholder="item.placeholder_text" v-inputFilter:phone/>
         </a-form-item>
   
         <a-form-item :label="item.customize_name" :required="item.is_sys==1" :style="{'border-bottom':'1px solid #f0f0f0'}" v-if="item.type_mark=='mcz_type_radio'" :label-col="{'span':setLabel(item.customize_name)}" :wrapper-col="{'span':setWrapper(item.customize_name)}">
             <a-radio-group v-model:value="item.radio" class="m-l-20">
               <a-radio :value="index" v-for="(item,index) in getOptions(item.single_options)" :key="index">{{item}}</a-radio>
              </a-radio-group>
         </a-form-item>
          <a-form-item :label="item.customize_name" :required="item.is_sys==1" :style="{'border-bottom':'1px solid #f0f0f0'}" v-if="item.type_mark=='mcz_type_date'" :label-col="{'span':setLabel(item.customize_name)}" :wrapper-col="{'span':setWrapper(item.customize_name)}">
             <a-space direction="vertical">
               <a-date-picker v-model:value="item.date" />
             </a-space>
          </a-form-item>
          
           <a-form-item :label="item.customize_name" v-if="item.type_mark=='mcz_type_checkbox'" :label-col="{'span':setLabel(item.customize_name)}" :wrapper-col="{'span':setWrapper(item.customize_name)}">
            <a-checkbox-group v-model:value="item.checkList">
               <a-checkbox :value="index" v-for="(item,index) in getOptions(item.many_options)" :key="index">{{item}}</a-checkbox>
            </a-checkbox-group>
           </a-form-item>
           <!--  -->
            <a-form-item :label="item.customize_name" :style="{'border-bottom':'1px solid #f0f0f0'}" v-if="item.type_mark=='mcz_type_area'" :label-col="{'span':setLabel(item.customize_name)}" :wrapper-col="{'span':setWrapper(item.customize_name)}" >
              <div class=" s_fonts12 s_bor3 s_shou s_flex_ali" style="padding:4px 10px;border:1px solid #d9d9d9;color:#d9d9d9;width:180px"><span class="flex_1 s_c999">请选择地区</span><DownOutlined class="m-l-5"/></div>
            </a-form-item>
       </div>
        <a-form-item label="">
           <div class="s_c999 s_fonts12">温馨提示</div>
           <div class="s_c999 s_fonts12 m-t-5">{{formInfo.tips}}</div>
       </a-form-item>
    </a-form>

    <a-modal  :keyboard="false" title="字段管理" centered :width='800' :footer="null" v-model:visible="showVisible" destroyOnClose @cancel="showVisible=false">
      <a-button type="primary" class="m-b-20" @click="addConfig">新增字段</a-button>
      <a-table :pagination='false' bordered rowKey='id' :columns='columns' :data-source='configData'>
        <template v-slot:action="{ record }">
           <div v-if="record.is_sys!=1">
             <a-button type="primary" class="m-r-20" @click="editConfig(record)">修改</a-button>
             <a-button type="primary" danger @click="deleteCustomizes(record)">删除</a-button>
           </div>
           <div v-else>系统默认数据,不支持修改</div>
        </template>
      </a-table>
    </a-modal>

     <a-modal  :keyboard="false" title="新增字段" centered :width='500' v-model:visible="configVisible" destroyOnClose @ok="cofirm" @cancel="cancelModal">
         <a-form :model="configTiem" ref="configRef" :label-col="{span:5,offset:0}" :wrapper-col="{span:12,offset:0}" labelAlign="left" :rules="rules">
             <a-form-item label="字段姓名" required name="customize_name" >
               <a-input v-model:value="configTiem.customize_name"  placeholder="请输入字段姓名"/>
             </a-form-item>
             <a-form-item label="字段类型" required name="type_name">
                <a-select v-model:value="configTiem.type_name"  style="width: 120px"  @change="handleChange">
                  <a-select-option v-for='item in options' :key='item.value' :value="item.value">{{item.label}}</a-select-option>
                </a-select>
             </a-form-item>
             <!--  -->
              <a-form-item label="输入长度" v-if="configTiem.type_mark=='mcz_type_text'" name="length">
               <a-input-number v-model:value="configTiem.length" type="number" placeholder="长度"/>
             </a-form-item>
              <a-form-item label="单选选项" required v-if="configTiem.type_mark=='mcz_type_radio'" help="选项1/选项2/选项3" name="single_options">
               <a-input v-model:value="configTiem.single_options"  placeholder="选项1/选项2/选项3"/>
              </a-form-item>
              <a-form-item label="多选选项" required v-if="configTiem.type_mark=='mcz_type_checkbox'" help="选项1/选项2/选项3" name="many_options">
               <a-input v-model:value="configTiem.many_options"  placeholder="选项1/选项2/选项3"/>
              </a-form-item>
             <!--  -->
              <a-form-item label="输入提示" required v-show="configTiem.type_mark=='mcz_type_text'||configTiem.type_mark=='mcz_type_phone'" name="placeholder_text">
                <a-input v-model:value="configTiem.placeholder_text"  placeholder="请输入提示"/>
             </a-form-item>
             <a-form-item label="状态" required :label-col="{span:4,offset:0}" name="is_enable">
               <a-radio-group v-model:value="configTiem.is_enable" class="m-l-20">
                <a-radio :value="1">启用</a-radio>
                <a-radio :value="0">禁用</a-radio>
               </a-radio-group>
             </a-form-item>
         </a-form>
     </a-modal>
  </div>
</template>

<script>
import { onMounted, reactive, ref, toRefs } from "vue";
import { DownOutlined } from "@ant-design/icons-vue";
import { message,Modal } from 'ant-design-vue';
import {addCustomize,customizes,editCustomize,delCustomizes,collectionTypes} from '@/api/member.js'
 import { iscode } from '@/utils/app';
import { filter } from 'lodash';

const columns = [{
     title: "字段名称",
     dataIndex: "customize_name",
},{
  title: "输入提示",
  dataIndex: "placeholder_text",
},
{
  title: "类型",
  dataIndex: "type_name",
},{
  title: "状态",
  dataIndex: "is_enable",
  customRender:function({record}){
    return record.is_enable==1?'启用':'禁用'
  }
},{
  title: "操作",
  key: "action",
  width:200,
  slots: { customRender: "action" },
}]

const options = [
  {
    value:'mcz_type_text',
    label:'文本',
  },
  {
    value:'mcz_type_radio',
    label:'单选框'
  },
  {
    value:'mcz_type_checkbox',
    label:'多选框'
  },
  {
    value:'mcz_type_date',
    label:'日期选择框'
  },
  {
    value:'mcz_type_phone',
    label:'手机'
  },
  {
    value:'mcz_type_area',
    label:'地区'
  }
]

export default {
  components: { DownOutlined },
  props: {
    formInfo: {
      type: Object,
      default: () => {},
    },
  },
  setup(props, { emit }) {
    const configRef = ref(null);
    const state = reactive({
      form:{
          name:'',
          phone:'',
          code:'',
          sex:0,
          date:'',
          checkList:[]
      },
      showVisible:false,
      configData:[],
      configVisible:false,
      configType:'add',
      configTiem:{ //新增项
         customize_name:'',
         placeholder_text:'',
         type_name:'文本',
         is_enable:1, //启用
         is_sys:0,
         is_enable_text:'启用',
         type_mark:'mcz_type_text',
         length:null,
         single_options:'',
         many_options:'',
         type_id:1
      },
      componentList:[],
      rules:{
         customize_name:[{required: true,message: '字段名称必填!',}],
         placeholder_text:[
           {
             required: true,
             validator:async (rule, value)=>{
                  if(state.configTiem.type_mark=='mcz_type_text' || state.configTiem.type_mark=='mcz_type_phone'){
                      if(!value){
                        return Promise.reject('提示语必填!');
                      }else{
                        return Promise.resolve();
                      }
                  }else{
                    return Promise.resolve();
                  }
             }
           }
         ],
        single_options:[
           {
             required: true,
             validator:async (rule, value)=>{
                  if(state.configTiem.type_mark=='mcz_type_radio'){
                      if(!value){
                        return Promise.reject('单选选项必填!');
                      }else{
                        return Promise.resolve();
                      }
                  }else{
                    return Promise.resolve();
                  }
             }
           }
         ],
         many_options:[
           {
             required: true,
             validator:async (rule, value)=>{
                  if(state.configTiem.type_mark=='mcz_type_checkbox'){
                      if(!value){
                        return Promise.reject('多选选项必填!');
                      }else{
                        return Promise.resolve();
                      }
                  }else{
                    return Promise.resolve();
                  }
             }
           }
         ],
         is_enable:[{required: true,message: '状态必选!',}]
       }
    });

    const methods= {
     async getConfigData(){
          state.showVisible = true;
          let res = await customizes().then(res=>res.data);
           if(iscode(res)){
             console.log(res)
             state.configData = res.data || [];
            //  methods.getCheckboxList()
           }else{
             message.error(res.msg);
           }
      },
      //新增
      addConfig(){
        state.configTiem = { //重置
         customize_name:'',
         placeholder_text:'',
         type_name:'文本',
         is_enable:1, //启用
         is_sys:0,
         is_enable_text:'启用',
         type_mark:'mcz_type_text',
         length:null,
         single_options:'',
         many_options:'',
         type_id:1
        },
        state.configType = 'add';
        state.configVisible = true;
         methods.getCollectionTypes()
      },
      handleChange(e){
        const type_obj = {'mcz_type_text':['文本',1],'mcz_type_radio':['单选框',2],'mcz_type_checkbox':['多选框',3],'mcz_type_date':['日期选择框',4],'mcz_type_phone':['手机',5],'mcz_type_phone_check':['手机(带验证)',6],'mcz_type_area':['地区',7]}
        state.configTiem.type_id = type_obj[e][1];
        state.configTiem.type_name = type_obj[e][0];
        state.configTiem.type_mark = e;
      },
      cancelModal(){
         configRef.value.resetFields()
      },
      cofirm(){
         configRef.value.validate().then(async (value)=>{
            const hide = message.loading("正在加载中...", 0);
            let res;
            if(state.configType =='add'){
              res = await addCustomize({...state.configTiem}).then(res=>res.data)
            }else{
               res = await editCustomize({...state.configTiem}).then(res=>res.data)
            }
            setTimeout(hide);
            if(iscode(res)){
               configRef.value.resetFields();
               state.configVisible=false;
               methods.getConfigData()
               emit('change')
            }else{
              message.error(res.msg);
            }
         }).catch((err)=>{
            message.error(err.errorFields[0].errors)
         })
      },
      //
      editConfig(record){
        console.log(record)
          state.configType = 'edit';
          state.configTiem = record;
          state.configVisible = true;
      },
      setConfigForm(data){
        
        state.componentList = data || [];
        console.log(state.componentList,'回访');
      },
      getOptions(option){
        if(option.length!=0){
           return option.split('/')
        }else{
          return []
        }
        
      },
      setLabel(str){
        const len = str.length + 1;
        return len <=5?5:len;
      },
      setWrapper(str){
         const len = 23 - str.length ;
        return len 
      },
      //删除
      deleteCustomizes(record){
        Modal.confirm({
            title:'删除后无法恢复，您确定要吗？',
           async onOk() {
             let res = await delCustomizes(record.id).then(res=>res.data);
              if(iscode(res)){
                message.success(res.msg);
                methods.getConfigData()
                 emit('change')
              }else{
                message.error(res.msg);
              }
           },
        })
      },
      //字段
     async getCollectionTypes(){
        console.log('111')
        let res = await collectionTypes().then(res=>res.data);
        if(iscode(res)){
          state.options = res.data.map((v)=>{
               return {
                 value:v.type_mark,
                 label:v.type_name
               }
          })
        }else{
          message.error(res.msg);
        }
      }
    }

    onMounted(()=>{
       
    })

    return {
      ...toRefs(state),
      columns,
      ...methods,
      options,
      configRef
    };
  },
};
</script>

<style lang="less" scoped>
.xing {
  position: relative;
  &::before {
    content: " ";
    color: red;
    font-size: 16px;
    margin-right: 2px;
  }
}

</style>
